// ============================================================================
// LOOKUP SERVICE
// ============================================================================
// API calls for lookup/reference data (statuses, etc.)

import { get } from '../client/axiosClient';
import { buildEndpoint } from '../endpoints/base.endpoints';

export interface StatusLookup {
  id: string;
  code: string;
  name: string;
  type: string;
  description?: string;
}

export const lookupService = {
  getStatuses: (type: string) =>
    get<StatusLookup[]>(buildEndpoint(`/lookups/statuses?type=${encodeURIComponent(type)}`)),
};

export default lookupService;
